"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLatestImports = void 0;
const sonar_http_1 = require("@sonar-software/sonar-http");
exports.getLatestImports = (0, sonar_http_1.createGetEndpoint)((request) => {
    var _a;
    return `/api/v3/core/imports/latest?${(0, sonar_http_1.getQueryString)({
        count: (_a = request === null || request === void 0 ? void 0 : request.count) !== null && _a !== void 0 ? _a : 1,
        organizationTypeId: request === null || request === void 0 ? void 0 : request.organizationTypeId
    })}`;
}, {
    skipAuthRefresh: true
});
//# sourceMappingURL=getLatestImports.js.map